/* Main app types */
import type { VaultAction } from '@ducat-unit/core';

// User can perform either a vault action or a wallet related action, we call it "user account action" since its related to the connected wallet account.
// Swap is an external non-protocol action, it represents swaping btc for unit in wallet (not vault).
export type UserAccountAction = VaultAction | 'swap';

export const UnitVaultActions: VaultAction[] = ['open', 'borrow', 'repay', 'repo', 'trim'];

export const LiquidationActions: VaultAction[] = ['liquidate', 'repo', 'trim'];

/** Keys within the `common.vaultActions` message namespace. */
export const VaultActionLabelKey: Record<UserAccountAction, string> = {
  repair: 'repair',
  open: 'open',
  close: 'close',
  borrow: 'borrow',
  deposit: 'deposit',
  repay: 'repay',
  withdraw: 'withdraw',
  liquidate: 'liquidate',
  repo: 'claim',
  trim: 'claim',
  swap: 'swap',
};
